async function handleDefaultCrossSell(mainProductData){
    setButtonLoadDots('crsBuyButton', 3000)
    const url = 'https://www.caffeinearmy.com.br/cart/add.js';
    const productItems= formatProductList('default')

    await clearCart()
    await insiderTracking.handleCrossSellpurchase(productItems, mainProductData)
    await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({items: productItems}),
      }).then(response => {
        setTimeout(() =>  window.location.href='/checkout', 400)
      }).catch((error) => {
        console.error('Error:', error);
      });
}


async function handlePrimeCrossSell(planConfig, mainProductData){
  setButtonLoadDots('crsPrimeButton', 4000)
  const productItems= formatProductList('prime')

  await insiderTracking.handlePdpSubscriptionClick( mainProductData, undefined, undefined, productItems, "pdp_cross_sell")
  const primeCheckoutURL = await handleCreatePrimeCheckout(productItems, planConfig)

  if(primeCheckoutURL){
    return window.location.href = `${primeCheckoutURL}`
  }
    
}

function formatProductList(variant){
  const productItems= []
  const selectedVariantsIds = document.querySelectorAll('.crs-product-variant');
  if(selectedVariantsIds){
      selectedVariantsIds.forEach((productInfo, i) => {
         if(productInfo.value){
          const productHandle = productInfo.value.split('--')[0]
          const productId = productInfo.value.split('--')[1]
          const productItem ={quantity: 1}
          if(variant === 'prime'){
            productItem.cycles = 12
            productItem.currentProduct = productHandle;
            productItem.id = productId;
          }else{
            productItem.id = productId;
            productItem.handle = productHandle;
          }
          
          productItems.push(productItem)
         }
      })
  }

  return productItems
}